/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration update request containing the new configuration data.
 * 
 * **Update Behavior:**
 * - Only the `configurationData` field is updated
 * - Configuration type, scope, and metadata remain unchanged
 * - Partial updates are supported (only specified fields are changed)
 * - All updated data is validated against the JSON schema
 * 
 * **Required Fields:**
 * - `configurationData` - JSON object containing the updated configuration values
 * 
 * **Validation:**
 * - All fields are validated against the configuration type's JSON schema
 * - Required fields must be present
 * - Data types and constraints are enforced
 * - Nested objects and arrays are supported
 * 
 * **Examples:**
 * 
 * **Security Policy Update:**
 * ```json
 * {
 *   "configurationData": {
 *     "minLength": 16,
 *     "requireUppercase": true,
 *     "requireLowercase": true,
 *     "requireNumbers": true,
 *     "requireSpecialChars": true,
 *     "maxAge": 60,
 *     "preventReuse": 10,
 *     "lockoutThreshold": 3,
 *     "lockoutDuration": 60
 *   }
 * }
 * ```
 * 
 * **Integration Update:**
 * ```json
 * {
 *   "configurationData": {
 *     "webhookUrl": "https://hooks.slack.com/services/NEW/WEBHOOK/URL",
 *     "channel": "#security-critical",
 *     "enabled": true,
 *     "severityLevels": ["CRITICAL"],
 *     "notificationTypes": ["CASE_CREATED", "CASE_CLOSED"]
 *   }
 * }
 * ```
 * 
 * @export
 * @interface UpdateConfigurationRequest
 */
export interface UpdateConfigurationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateConfigurationRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateConfigurationRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateConfigurationRequest
     */
    configurationData?: { [key: string]: any; };
    /**
     * Optional JSON metadata patch merged into existing metadata (publisherUserId is immutable)
     * @type {{ [key: string]: any; }}
     * @memberof UpdateConfigurationRequest
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof UpdateConfigurationRequest
     */
    _default?: boolean;
}

/**
 * Check if a given object implements the UpdateConfigurationRequest interface.
 */
export function instanceOfUpdateConfigurationRequest(value: object): value is UpdateConfigurationRequest {
    return true;
}

export function UpdateConfigurationRequestFromJSON(json: any): UpdateConfigurationRequest {
    return UpdateConfigurationRequestFromJSONTyped(json, false);
}

export function UpdateConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'configurationData': json['configurationData'] == null ? undefined : json['configurationData'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function UpdateConfigurationRequestToJSON(json: any): UpdateConfigurationRequest {
    return UpdateConfigurationRequestToJSONTyped(json, false);
}

export function UpdateConfigurationRequestToJSONTyped(value?: UpdateConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'configurationData': value['configurationData'],
        'metadata': value['metadata'],
        'default': value['_default'],
    };
}

